import React, { useState } from "react";
import { Icon } from "../";

const IntegrationFilters = ({
  searchTerm,
  onSearchChange,
  placeholder = "Search by name...",
}) => {
  const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm || "");

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setLocalSearchTerm(value);
    onSearchChange(value);
  };

  const handleClearSearch = () => {
    setLocalSearchTerm("");
    onSearchChange("");
  };

  return (
    <div className="mb-6 rounded-lg border border-gray-800 bg-gray-900 p-4">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        {/* Left side - Search */}
        <div className="flex flex-1 flex-col gap-4 sm:flex-row">
          {/* Search Input */}
          <div className="min-w-0 flex-1">
            <div className="relative">
              <div className="pointer-events-none absolute top-1/2 left-3 flex -translate-y-1/2 transform items-center">
                <Icon name="Search" className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="text"
                placeholder={placeholder}
                value={localSearchTerm}
                onChange={handleSearchChange}
                className="h-10 w-full rounded-lg border border-gray-700 bg-gray-800 px-4 py-2 pr-10 pl-10 text-white placeholder-gray-400 focus:border-transparent focus:ring-2 focus:ring-blue-500 focus:outline-none"
              />
              {localSearchTerm && (
                <button
                  onClick={handleClearSearch}
                  className="absolute top-1/2 right-2 flex h-5 w-5 -translate-y-1/2 transform cursor-pointer items-center justify-center rounded-full bg-gray-600 transition-colors hover:bg-gray-500"
                  type="button"
                >
                  <svg
                    className="h-3 w-3 text-gray-300 hover:text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntegrationFilters;
